function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Location from '../geom/Location';
import Coordinate from '../geom/Coordinate';
import Node from './Node';
import NodeMap from './NodeMap';
import Orientation from '../algorithm/Orientation';
import DirectedEdge from './DirectedEdge';
import System from '../../../../java/lang/System';
import ArrayList from '../../../../java/util/ArrayList';
import Quadrant from './Quadrant';
import NodeFactory from './NodeFactory';
var PlanarGraph = /*#__PURE__*/function () {
  function PlanarGraph() {
    _classCallCheck(this, PlanarGraph);
    PlanarGraph.constructor_.apply(this, arguments);
  }
  return _createClass(PlanarGraph, [{
    key: "printEdges",
    value: function printEdges(out) {
      out.println('Edges:');
      for (var i = 0; i < this._edges.size(); i++) {
        out.println('edge ' + i + ':');
        var e = this._edges.get(i);
        e.print(out);
        e.eiList.print(out);
      }
    }
  }, {
    key: "find",
    value: function find(coord) {
      return this._nodes.find(coord);
    }
  }, {
    key: "addNode",
    value: function addNode() {
      if (arguments[0] instanceof Node) {
        var node = arguments[0];
        return this._nodes.addNode(node);
      } else if (arguments[0] instanceof Coordinate) {
        var coord = arguments[0];
        return this._nodes.addNode(coord);
      }
    }
  }, {
    key: "getNodeIterator",
    value: function getNodeIterator() {
      return this._nodes.iterator();
    }
  }, {
    key: "linkResultDirectedEdges",
    value: function linkResultDirectedEdges() {
      for (var nodeit = this._nodes.iterator(); nodeit.hasNext();) {
        var node = nodeit.next();
        node.getEdges().linkResultDirectedEdges();
      }
    }
  }, {
    key: "debugPrintln",
    value: function debugPrintln(o) {
      System.out.println(o);
    }
  }, {
    key: "isBoundaryNode",
    value: function isBoundaryNode(geomIndex, coord) {
      var node = this._nodes.find(coord);
      if (node === null) return false;
      var label = node.getLabel();
      if (label !== null && label.getLocation(geomIndex) === Location.BOUNDARY) return true;
      return false;
    }
  }, {
    key: "linkAllDirectedEdges",
    value: function linkAllDirectedEdges() {
      for (var nodeit = this._nodes.iterator(); nodeit.hasNext();) {
        var node = nodeit.next();
        node.getEdges().linkAllDirectedEdges();
      }
    }
  }, {
    key: "matchInSameDirection",
    value: function matchInSameDirection(p0, p1, ep0, ep1) {
      if (!p0.equals(ep0)) return false;
      if (Orientation.index(p0, p1, ep1) === Orientation.COLLINEAR && Quadrant.quadrant(p0, p1) === Quadrant.quadrant(ep0, ep1)) return true;
      return false;
    }
  }, {
    key: "getEdgeEnds",
    value: function getEdgeEnds() {
      return this._edgeEndList;
    }
  }, {
    key: "debugPrint",
    value: function debugPrint(o) {
      System.out.print(o);
    }
  }, {
    key: "getEdgeIterator",
    value: function getEdgeIterator() {
      return this._edges.iterator();
    }
  }, {
    key: "findEdgeInSameDirection",
    value: function findEdgeInSameDirection(p0, p1) {
      for (var i = 0; i < this._edges.size(); i++) {
        var e = this._edges.get(i);
        var eCoord = e.getCoordinates();
        if (this.matchInSameDirection(p0, p1, eCoord[0], eCoord[1])) return e;
        if (this.matchInSameDirection(p0, p1, eCoord[eCoord.length - 1], eCoord[eCoord.length - 2])) return e;
      }
      return null;
    }
  }, {
    key: "insertEdge",
    value: function insertEdge(e) {
      this._edges.add(e);
    }
  }, {
    key: "findEdgeEnd",
    value: function findEdgeEnd(e) {
      for (var i = this.getEdgeEnds().iterator(); i.hasNext();) {
        var ee = i.next();
        if (ee.getEdge() === e) return ee;
      }
      return null;
    }
  }, {
    key: "addEdges",
    value: function addEdges(edgesToAdd) {
      for (var it = edgesToAdd.iterator(); it.hasNext();) {
        var e = it.next();
        this._edges.add(e);
        var de1 = new DirectedEdge(e, true);
        var de2 = new DirectedEdge(e, false);
        de1.setSym(de2);
        de2.setSym(de1);
        this.add(de1);
        this.add(de2);
      }
    }
  }, {
    key: "add",
    value: function add(e) {
      this._nodes.add(e);
      this._edgeEndList.add(e);
    }
  }, {
    key: "getNodes",
    value: function getNodes() {
      return this._nodes.values();
    }
  }, {
    key: "findEdge",
    value: function findEdge(p0, p1) {
      for (var i = 0; i < this._edges.size(); i++) {
        var e = this._edges.get(i);
        var eCoord = e.getCoordinates();
        if (p0.equals(eCoord[0]) && p1.equals(eCoord[1])) return e;
      }
      return null;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return PlanarGraph;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "linkResultDirectedEdges",
    value: function linkResultDirectedEdges(nodes) {
      for (var nodeit = nodes.iterator(); nodeit.hasNext();) {
        var node = nodeit.next();
        node.getEdges().linkResultDirectedEdges();
      }
    }
  }]);
}();
export { PlanarGraph as default };
PlanarGraph.constructor_ = function () {
  this._edges = new ArrayList();
  this._nodes = null;
  this._edgeEndList = new ArrayList();
  if (arguments.length === 0) {
    this._nodes = new NodeMap(new NodeFactory());
  } else if (arguments.length === 1) {
    var nodeFact = arguments[0];
    this._nodes = new NodeMap(nodeFact);
  }
};